module.exports = __webpack_public_path__ + "img/slide-1.1f2ef7f1.jpg";